// src/app/guards/auth.guard.ts (Versión Modular - con la última corrección)

import { inject, Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { Auth } from '@angular/fire/auth'; // <--- Nueva forma de inyectar Auth
import { onAuthStateChanged, User as FirebaseAuthUser } from 'firebase/auth'; // <--- Directamente del SDK de Firebase
import { UserService } from 'src/app/services';
import { switchMap, take, map, catchError } from 'rxjs/operators';
import { Observable, of, from } from 'rxjs'; // <--- Importamos 'from'

import { User } from '../models/user'; // <--- ADD THIS LINE


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  private auth: Auth = inject(Auth); // <--- Inyección de la instancia Auth modular
  private router = inject(Router);
  private userService = inject(UserService);

  canActivate(): Observable<boolean | UrlTree> {
    // Convertimos la Promise de onAuthStateChanged a un Observable usando 'from'
    return from(new Promise<FirebaseAuthUser | null>((resolve) => {
      const unsubscribe = onAuthStateChanged(this.auth, (user) => {
        unsubscribe(); // Nos desuscribimos después del primer estado
        resolve(user);
      });
    })).pipe(
      take(1),
      switchMap((firebaseUser) => {
        if (firebaseUser) {
          // Si hay un usuario, consultamos Firestore y devolvemos ese Observable
          return this.userService.getUserById(firebaseUser.uid).pipe(
            map((appUser: User | undefined) => {
            if (appUser && typeof appUser.mail === 'string' && typeof appUser.displayName === 'string') {
              this.userService.setUser(appUser);
              return true;
            } else {
              console.warn('Usuario incompleto o no encontrado en Firestore');
              localStorage.clear();
              return this.router.createUrlTree(['/login']);
            }
          }),
            catchError((error) => { // <--- Manejo de errores de la consulta a Firestore
              console.error('Error al obtener datos de usuario de Firestore en AuthGuard (catchError):', error);
              localStorage.clear();
              return of(this.router.createUrlTree(['/login']));
            })
          );
        } else {
          // Si no hay usuario, redirigimos directamente
          console.log('No hay usuario autenticado. Redirigiendo a login.');
          localStorage.clear();
          return of(this.router.createUrlTree(['/login']));
        }
      })
    );
  }

  canLoad(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }
}